import { useInfiniteQuery } from 'react-query';
import { BOND_SEARCH_DATA_CACHE_KEY } from '../../Constants';
import { fetchDocumentSearchData } from '../../services/document-search.service';
import { addDateFilter, calculateDates } from '../../utils/date.utils';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (docType, sort, text, reportType, filterConfig, issueDateFilter, maturityDateFilter, pageSize) => {
  const { startDate: issueStartDate, endDate: issueEndDate } = calculateDates(issueDateFilter);
  const { startDate: maturityStartDate, endDate: maturityEndDate } = calculateDates(maturityDateFilter);
  const cacheKeys: string[] = [docType, sort?.field, sort?.order, text, reportType, issueStartDate, issueEndDate, maturityStartDate, maturityEndDate];
  const filters: any = {};

  Object.keys(filterConfig).forEach((key) => {
    filters[key] = {
      values: filterConfig[key],
    };

    for (const value of filterConfig[key]) {
      cacheKeys.push(`${key}:${value}`);
    }
  });

  addDateFilter(filters, 'issue_date', issueStartDate, issueEndDate);
  addDateFilter(filters, 'maturity_date', maturityStartDate, maturityEndDate);

  return useInfiniteQuery<any, Error>([BOND_SEARCH_DATA_CACHE_KEY, ...cacheKeys], async ({ pageParam }) => fetchDocumentSearchData(docType, sort, text, reportType, filters, pageSize, pageParam), {
    enabled: !!text || Object.keys(filters).length > 0,
    getNextPageParam: (lastPage, pages) => pages.length + 1,
  });
};
